import React, { useState } from "react";
import { Table } from "antd";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { DialogComponent } from "../common/DialogComponent";
import MavDeviceDetails from "./MavDeviceDetails";
import NoDataFound from "./NoDataFound";
import { downloadJsonToCsv } from "../../util/common";
import ApiFailedError from "./ApiFailedError";
function MavDevices({ data, loading, date, reportData, isError }: any) {
    const [detail, setDetail] = useState(null);
    const isNoData = !loading && data.length === 0;
    const columns: any = [
        {
            title: "Device",
            dataIndex: "deviceName",
            sorter: (a: any, b: any) => a.deviceName.localeCompare(b.deviceName),
            showSorterTooltip: false,
            width: "35%",
        },
        {
            title: "User",
            dataIndex: ["firstName", "lastName"],
            sorter: (a: any, b: any) => a.firstName.localeCompare(b.firstName),
            showSorterTooltip: false,
            width: "35%",
            render: (text: any, row: any) => (
                <span>
                    {row["firstName"]} {row["lastName"]}
                </span>
            ),
        },
        {
            title: "Last Scan",
            dataIndex: "lastScan",
            sorter: (a: any, b: any) => {
                const c: any = new Date(a.lastScan);
                const d: any = new Date(b.lastScan);
                return c - d;
            },
            render: (text: any) => <span>{moment(text).format("MM/DD/YY hh:mm A")}</span>,
            showSorterTooltip: false,
            defaultSortOrder: "descend",
            width: "20%",
            className: "hide-mobile",
        },
        {
            title: "Risks",
            dataIndex: "risks",
            sorter: (a: any, b: any) => a.risks - b.risks,
            showSorterTooltip: false,
            width: "5%",
            render: (text: string, rowData: any) => (
                <Link
                    to="/"
                    className="default_link"
                    onClick={(e: any) => {
                        e.preventDefault();
                        setDetail(rowData);
                    }}
                    style={{ padding: "5px" }}
                >
                    {text}
                </Link>
            ),
        },
    ];
    const closeDialog = () => {
        setDetail(null);
    };
    return isNoData ? (
        <div className="row">
            <div className="col-xs">
                <div className="box">{isError ? <ApiFailedError fromApiError /> : <NoDataFound />}</div>
            </div>
        </div>
    ) : (
        <div>
            <div className="row">
                <div className={loading ? "box loading w-100 margin-1" : "box w-100 margin-1"}>
                    <div className="box-header pb-24">
                        <div className="col-xs-12 col-no-gutter flex-grow-null flex-end">
                            <button
                                type="button"
                                className="btn-default btn-primary"
                                id="btn-add-employee"
                                disabled={reportData.length === 0}
                                onClick={() => {
                                    let currentDate = new Date();
                                    let dateFormat = currentDate.getMonth() + 1 + "_" + currentDate.getDate() + "_" + currentDate.getFullYear();
                                    downloadJsonToCsv(reportData, `MobileAttackViewReport-${dateFormat}.csv`);
                                }}
                            >
                                <span className="btn-text">Generate Report</span>
                            </button>
                        </div>
                    </div>

                    {!loading && (
                        <div className="box-content">
                            <Table columns={columns} rowKey="deviceId" dataSource={data} pagination={false} sortDirections={["ascend", "descend", "ascend"]} />
                        </div>
                    )}
                </div>
            </div>
            {detail && (
                <div className="mav-detail-dialog">
                    <DialogComponent dialogId="dialog-action-complete" title="Device detail" closeDialog={closeDialog}>
                        <MavDeviceDetails detail={detail} date={date} closeDialog={closeDialog} />
                    </DialogComponent>
                </div>
            )}
        </div>
    );
}

export default MavDevices;
